import axios from "axios";

export default function getAccessRight({ uuid }) {
  const promise = new Promise((resolve, reject) =>
    axios
      .get(`/account/system-admin/api/v1/admin-role/access-right/${uuid}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );

  return promise;
}
